export var AiConversationStatusEnum;
(function (AiConversationStatusEnum) {
    AiConversationStatusEnum["ACTIVE"] = "active";
    AiConversationStatusEnum["COMPLETED"] = "completed";
    AiConversationStatusEnum["ABANDONED"] = "abandoned";
})(AiConversationStatusEnum || (AiConversationStatusEnum = {}));
export var AiResourceTypeEnum;
(function (AiResourceTypeEnum) {
    AiResourceTypeEnum["WORKFLOW"] = "workflow";
})(AiResourceTypeEnum || (AiResourceTypeEnum = {}));
export var AiAgentTypeEnum;
(function (AiAgentTypeEnum) {
    AiAgentTypeEnum["GENERATE_WORKFLOW"] = "generate-workflow";
})(AiAgentTypeEnum || (AiAgentTypeEnum = {}));
export var AiMessageRoleEnum;
(function (AiMessageRoleEnum) {
    AiMessageRoleEnum["USER"] = "user";
    AiMessageRoleEnum["ASSISTANT"] = "assistant";
    AiMessageRoleEnum["SYSTEM"] = "system";
})(AiMessageRoleEnum || (AiMessageRoleEnum = {}));
export var SnapshotSourceTypeEnum;
(function (SnapshotSourceTypeEnum) {
    SnapshotSourceTypeEnum["AI_CHAT"] = "ai-chat";
})(SnapshotSourceTypeEnum || (SnapshotSourceTypeEnum = {}));
export var AiWorkflowToolsEnum;
(function (AiWorkflowToolsEnum) {
    AiWorkflowToolsEnum["REASONING"] = "reasoning";
    AiWorkflowToolsEnum["RETRIEVE_ORGANIZATION_META"] = "retrieveOrganizationMeta";
    AiWorkflowToolsEnum["SET_WORKFLOW_METADATA"] = "setWorkflowMetadata";
    AiWorkflowToolsEnum["ADD_STEP"] = "addStep";
    AiWorkflowToolsEnum["ADD_STEP_IN_BETWEEN"] = "addStepInBetween";
    AiWorkflowToolsEnum["EDIT_STEP_CONTENT"] = "editStepContent";
    AiWorkflowToolsEnum["UPDATE_STEP_CONDITIONS"] = "updateStepConditions";
    AiWorkflowToolsEnum["REMOVE_STEP"] = "removeStep";
    AiWorkflowToolsEnum["MOVE_STEP"] = "moveStep";
    AiWorkflowToolsEnum["UPDATE_PAYLOAD_SCHEMA"] = "updatePayloadSchema";
})(AiWorkflowToolsEnum || (AiWorkflowToolsEnum = {}));
export var AiWorkflowToolsNameEnum;
(function (AiWorkflowToolsNameEnum) {
    AiWorkflowToolsNameEnum["REASONING"] = "tool-reasoning";
    AiWorkflowToolsNameEnum["RETRIEVE_ORGANIZATION_META"] = "tool-retrieveOrganizationMeta";
    AiWorkflowToolsNameEnum["SET_WORKFLOW_METADATA"] = "tool-setWorkflowMetadata";
    AiWorkflowToolsNameEnum["ADD_STEP"] = "tool-addStep";
    AiWorkflowToolsNameEnum["ADD_STEP_IN_BETWEEN"] = "tool-addStepInBetween";
    AiWorkflowToolsNameEnum["EDIT_STEP_CONTENT"] = "tool-editStepContent";
    AiWorkflowToolsNameEnum["UPDATE_STEP_CONDITIONS"] = "tool-updateStepConditions";
    AiWorkflowToolsNameEnum["REMOVE_STEP"] = "tool-removeStep";
    AiWorkflowToolsNameEnum["MOVE_STEP"] = "tool-moveStep";
    AiWorkflowToolsNameEnum["UPDATE_PAYLOAD_SCHEMA"] = "tool-updatePayloadSchema";
})(AiWorkflowToolsNameEnum || (AiWorkflowToolsNameEnum = {}));
export var AiResumeActionEnum;
(function (AiResumeActionEnum) {
    AiResumeActionEnum["TRY_AGAIN"] = "tryAgain";
    AiResumeActionEnum["REVERT"] = "revert";
})(AiResumeActionEnum || (AiResumeActionEnum = {}));
export var AiWorkflowSuggestion;
(function (AiWorkflowSuggestion) {
    AiWorkflowSuggestion["AUTOCOMPLETE"] = "Autocomplete this workflow";
    AiWorkflowSuggestion["APPLY_CONDITIONS"] = "Apply step conditions";
    AiWorkflowSuggestion["IMPROVE_MESSAGING"] = "Improve messaging";
    AiWorkflowSuggestion["FIX_WORKFLOW_ISSUES"] = "Fix workflow issues";
    AiWorkflowSuggestion["FIX_STEP_ISSUES"] = "Fix step issues";
    AiWorkflowSuggestion["GENERATE_STEP_CONTENT"] = "Generate step content";
})(AiWorkflowSuggestion || (AiWorkflowSuggestion = {}));
//# sourceMappingURL=ai.js.map